import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { Stack, Typography } from '@mui/material';
import { map } from 'lodash';
import { PenStyled } from './styles';
import type { InventoryListViewIncludedProps } from './types';
import { useInventoryListViewIncluded } from './hooks/useInventoryListViewIncluded';

export const InventoryListViewIncluded = ({
  data,
  onAdvanced,
  isEmpty,
}: InventoryListViewIncludedProps) => {
  const { os, device } = useInventoryListViewIncluded({
    data,
    isEmpty,
  });
  return (
    <Stack
      direction="row"
      display="inline-flex"
      alignItems="center"
      spacing={1}
    >
      <Typography variant="body2">
        {[
          os.all ? 'All Operating Systems' : map(os.data, 'value'),
          device.all ? 'All Devices' : map(device.data, 'value'),
        ]
          .flatMap(v => v)
          .join(', ')}
      </Typography>
      <PenStyled
        role="button"
        onClick={() => {
          onAdvanced();
        }}
        icon={faPen}
      />
    </Stack>
  );
};
